import { action, makeObservable, observable } from 'mobx';

export class BetNotificationStore {
  betNotifications = [];

  constructor() {
    makeObservable(this,{
      betNotifications: observable.deep,
      setBetNotification: action.bound,
      removeNotification: action.bound
    });
  }

  setBetNotification(betNotification) {
    let list = [...this.betNotifications]
    if (this.betNotifications.length >= 5) {
      list.shift();
      list.push(betNotification)
      this.betNotifications =  [...list]
    } else {
      list.push(betNotification);
      this.betNotifications = [...list];
    }
  }

  removeNotification(value) {
    if (this.betNotifications.length) {
      let list = [...this.betNotifications]
      if (value && value === 'all') {
        this.betNotifications  = [];
      }
      list.shift();
      this.betNotifications = list;
    }
  }
}

export const betNotificationStore = new BetNotificationStore();
